import permissionCheck from '../util/PermCheck';

const widgetList = [
  {
    shortName: 'unpaidVouchers',
    name: 'Unpaid Vouchers',
    size: 'large',
    permission: 'VOUCHER_S',
  },
  {
    shortName: 'grossIncome',
    name: 'Gross Income',
    size: 'large',
    permission: null,
  },
  {
    shortName: 'netIncome',
    name: 'Net Income',
    size: 'large',
    permission: null,
  },
  {
    shortName: 'syncStatus',
    name: 'Sync Status',
    size: 'medium',
    permission: 'ORG_M',
  },
  {
    shortName: 'topAgents',
    name: 'Top Agents',
    size: 'medium',
    permission: null,
  },
  {
    shortName: 'reports',
    name: 'Reports',
    size: 'large',
    permission: 'DEAL_S',
  },
  {
    shortName: 'totalDealsNet',
    name: 'Net Total Deals',
    size: 'small',
    permission: null,
  },
  {
    shortName: 'completeDealsNet',
    name: 'Net Complete Deals',
    size: 'small',
    permission: null,
  },
  {
    shortName: 'unmappedDealsNet',
    name: 'Net Unmapped Deals',
    size: 'small',
    permission: null,
  },
  {
    shortName: 'atRiskDealsNet',
    name: 'Net At Risk Deals',
    size: 'small',
    permission: null,
  },
  {
    shortName: 'totalDealsGross',
    name: 'Gross Total Deals',
    size: 'small',
    permission: null,
  },
  {
    shortName: 'completeDealsGross',
    name: 'Gross Complete Deals',
    size: 'small',
    permission: null,
  },
  {
    shortName: 'unmappedDealsGross',
    name: 'Gross Unmapped Deals',
    size: 'small',
    permission: null,
  },
  {
    shortName: 'atRiskDealsGross',
    name: 'Gross At Risk Deals',
    size: 'small',
    permission: null,
  },
  {
    shortName: 'smEmpty',
    name: 'Empty',
    size: 'small',
    permission: null,
  },
  {
    shortName: 'mdEmpty',
    name: 'Empty',
    size: 'medium',
    permission: null,
  },
  {
    shortName: 'lgEmpty',
    name: 'Empty',
    size: 'large',
    permission: null,
  },
  {
    shortName: 'recentComDeals',
    name: 'Recently Completed Deals',
    size: 'medium',
    permission: null,
  },
  {
    shortName: 'topOpenDeals',
    name: 'Top Open Deals',
    size: 'medium',
    permission: null,
  },
];

const getSizeFromLength = len => {
  if (len === 4) return 'small';
  if (len === 2) return 'medium';
  return 'large';
};

const getWidgetFromShortName = name =>
  widgetList.find(widget => widget.shortName === name);

const getViableWidgets = curSize =>
  widgetList.filter(
    ({ size, permission }) => curSize === size && permissionCheck(permission),
  );

export {
  getViableWidgets,
  getWidgetFromShortName,
  widgetList,
  getSizeFromLength,
};
